import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Button } from "@/components/ui/button";
import { Heart } from "lucide-react";

export default function Wishlist() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/wishlist").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-testid="wishlist-page">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 rounded-xl bg-saffron/10 text-saffron flex items-center justify-center">
          <Heart className="w-6 h-6 fill-saffron" />
        </div>
        <div>
          <h1 className="font-display text-3xl sm:text-4xl">My Wishlist</h1>
          <p className="text-muted-foreground text-sm">{items.length} saved {items.length === 1 ? "item" : "items"}</p>
        </div>
      </div>

      {loading ? (
        <div className="py-12 text-center text-muted-foreground">Loading...</div>
      ) : items.length === 0 ? (
        <div className="bg-white border border-border rounded-2xl p-12 text-center" data-testid="empty-wishlist">
          <Heart className="w-12 h-12 text-muted-foreground mx-auto mb-3" />
          <h3 className="font-display text-xl mb-1">Your wishlist is empty</h3>
          <p className="text-sm text-muted-foreground mb-5">Tap the heart on any tour or experience to save it for later.</p>
          <Link to="/"><Button className="bg-saffron hover:bg-saffron-dark text-white">Discover packages</Button></Link>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {items.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
